import React, { useEffect, useState, useRef } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  BooleanField,
  BooleanInput,
  AutocompleteInput,
  ReferenceInput,
  useInput,
  SelectInput,
} from 'react-admin'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { Autocomplete, Container, Skeleton, TextField as MuiTextField, Dialog, DialogTitle, DialogContent, Button } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { userServices } from 'src/services/reservation/user/user.service'
import { countryServices } from 'src/services/reservation/country/country.service'
import { AutocompleteInput as AutocompleteInputCustom } from 'src/components/uiElements/fields/AutocompleteInput'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_EXPORT } from 'src/helper/Permission'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { BusinessUnitExportButton } from './logic/BusinessUnitExportButon'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { FormProvider, useForm } from 'react-hook-form'
import { CATEGORY_OPTIONS } from './logic/categoryOptions'
import { DeleteButtonWithConfirmation } from './logic/CustomDeleteButton'

const CountryInput = ({ label, source }) => {
  const [loadingCountryList, setLoadingCountryList] = useState(false)
  const [countryList, setCountryList] = useState([])

  const getCountry = async (long_name) => {
    try {
      setLoadingCountryList(true)
      const allCountries = await countryServices.getByAll({ long_name: long_name })
      setCountryList(allCountries)
      setLoadingCountryList(false)
    } catch (error) {
      setCountryList([])
      setLoadingCountryList(false)
    }
  }

  return (
    <AutocompleteInputCustom
      source={source}
      label={label}
      options={countryList}
      loading={loadingCountryList}
      optionsText={['long_name']}
      optionValue='id'
      onSearch={getCountry}
      resetOnLoad={false}
      style={{ width: '300px' }}
      useOptionValue={true}
      positionOptionsText={0}
    />
  )
}

/* const ManegerResponsibleInput = ({ label, source }) => {
  const [inputValue, setInputValue] = useState('')
  const [userList, setUserList] = useState([])
  const [loadingUserList, setLoadingUserList] = useState(false)
  const [filteredChoices, setFilteredChoices] = useState(userList)


  const renderOptionText = (choice) => `${choice.firstname} ${choice.surname}`

  useEffect(() => {
    // Filtrar choices basado en el inputValue
    const filtered = userList.filter((choice) =>
      `${choice.firstname} ${choice.surname}`.toLowerCase().includes(inputValue.toLowerCase())
    )
    setFilteredChoices(filtered)
  }, [inputValue, userList])

  
  const getUser = async () => {
    try {
      setLoadingUserList(true)
      const allUsers = await reservationServices.userReservtionFilter({ is_active: true })
      setUserList(allUsers)
      setLoadingUserList(false)
    } catch (error) {
      setUserList([])
      setLoadingUserList(false)
    }
  }

  useEffect(() => {
    getUser()
  }, [])

  return (<>
    {loadingUserList ? (
        <EditInputsWrap label={label}>
          <Skeleton variant='rectangular' width={'200px'} height={40} />
        </EditInputsWrap>
      ) : (
        <AutocompleteInput
          label={label}
          source={source}
          choices={filteredChoices}
          optionText={renderOptionText}
          loading={loadingUserList}
          style={{ width: '300px' }}
          onInputChange={(e) => setInputValue(e.target.value)}
        />
      )}
    </>
  )
} */

const BusinessUnitInput = ({ label, source }) => {
  const [choices, setChoices] = useState([])
  const [loading, setLoading] = useState(false)
  // Manejar el cambio en el input y actualizar los choices

  const getBusinessUnitByLongName = async (fiscal_data) => {
    try {
      setLoading(true)
      const fetchedChoices = await businessUnitServices.business_unit_filter({
        fiscal_data__name__ilike: fiscal_data,
      })
      setChoices(fetchedChoices)
    } catch (error) {
      setChoices([])
    } finally {
      setLoading(false)
    }
  }

  const handleInputChange = async (query) => {
    if (query.length > 2) {
      await getBusinessUnitByLongName(query)
    }
  }

  return (
    <AutocompleteInputCustom
      source={source}
      label={label}
      options={choices}
      loading={loading}
      optionsText={['fiscal_data_name']}
      optionValue='id'
      onSearch={handleInputChange}
      resetOnLoad={false}
      style={{ width: '300px' }}
      useOptionValue={true}
      positionOptionsText={0}
    />
  )
}

const WorkUnitInput = ({ label, source }) => {
  const [choices, setChoices] = useState([])
  const [loading, setLoading] = useState(false)
  // Manejar el cambio en el input y actualizar los choices

  const getWorkUnit = async (long_name) => {
    try {
      setLoading(true)
      const allWorkUnit = await workUnitServices.getByAll({ long_name: long_name })
      setChoices(allWorkUnit)
      setLoading(false)
    } catch (error) {
      setChoices([])
      setLoading(false)
    }
  }

  const handleInputChange = async (query) => {
    if (query.length > 2) {
      await getWorkUnit(query)
    }
  }

  

  return (
    <AutocompleteInputCustom
      source={source}
      label={label}
      options={choices}
      loading={loading}
      optionsText={['long_name']}
      optionValue='id'
      onSearch={handleInputChange}
      resetOnLoad={false}
      style={{ width: '300px' }}
      useOptionValue={true}
      positionOptionsText={0}
    />
  )
}

const ResponsibleInput = ({ label, source }) => {
  const translate = useTranslate()
  const [inputValue, setInputValue] = useState()
  const [userList, setUserList] = useState([])
  const [filteredChoices, setFilteredChoices] = useState(userList)
  const [loadingUserList, setLoadingUserList] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const form = useForm()
  const {
    field: {value,onChange },
  } = useInput({ source });

  let searchTimeout

  useEffect(()=>{
    if(value){
      const localValue = localStorage.getItem(source) ? JSON.parse(localStorage.getItem(source)) : null
      setInputValue(localValue)
      form.setValue(source,localValue)
    } else {
      localStorage.removeItem(source)
    }
  },[value])

  const filterOptions = async (user, length = 2) =>{
    clearTimeout(searchTimeout)
        if (
          (!user?.firstname || user.firstname.length < length) &&
          (!user?.surname || user.surname.length < length)
        ) {
          setFilteredChoices([])
          return
        }
    
        searchTimeout = setTimeout(async () => {
          try {
            setLoadingUserList(true)
            let filter = {
              limit: 20
            }
            if (user?.firstname) {
              filter.firstname = user?.firstname
            }
            if (user?.surname) {
              filter.surname = user?.surname
            }
            const allUser = await reservationServices.userReservtionFilter(filter)
            setFilteredChoices(allUser)
          } catch (error) {
            setFilteredChoices([])
          } finally {
            setLoadingUserList(false)
          }
        }, 1000)
  }


  useEffect(() => {
    getUser()
  }, [])



  const getUser = async () => {
    try {
      setLoadingUserList(true)
      const allUsers = await reservationServices.userReservtionFilter({ is_active: true })
      setUserList(allUsers)
      setFilteredChoices(allUsers)
      setLoadingUserList(false)
    } catch (error) {
      setUserList([])
      setLoadingUserList(false)
    }
  }

  const closeDialog = () =>{
    setOpenDialog(false)
    onChange(inputValue?.id_reservation_user)
    localStorage.setItem(source, JSON.stringify(inputValue))
  }

  return (
    <>
        <Button variant='outlined' onClick={()=>setOpenDialog(true)}>
          {inputValue ? `${inputValue.firstname} ${inputValue.surname}` : label}
        </Button>
        <Dialog
          open={openDialog}
          onClose={closeDialog}
        >
          <DialogTitle>
            {label}
          </DialogTitle>
          <DialogContent>
            <FormProvider {...form}>
              <div style={{display:'flex', flexDirection:'column'}}>
                { (
                  <MultiAutocompleteInput
                    source={source}
                    options={filteredChoices}
                    loading={loadingUserList}
                    onChange={(val)=>{
                      setInputValue(val.target.value)
                    }}
                    optionsText={['firstname', 'surname']}
                    equalToValueByOptionValue={true}
                    isOptionEqualToValue={(option, value) => option.id_reservation_user === value}
                    onSearch={filterOptions}
                    resetOnLoad={false}
                    fields={['firstname', 'surname']}
                    disablePortal={false}
                  />
                  )}
                  <Button onClick={closeDialog} style={{marginTop:'15px',alignSelf:'flex-end'}} variant='contained'>
                    {translate('ra.action.back')}
                  </Button>
                </div>
              </FormProvider>
          </DialogContent>
        </Dialog>
    </>
  )
}

export const BusinessUnitList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching, page, filterValues } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  const prevPageRef = useRef()
  const prevFiltersRef = useRef(filterValues)

  const [pageChanged, setPageChanged] = useState(false)

  useEffect(() => {
    // Comprobar si la página ha cambiado y si isFetching es true
    if (prevPageRef.current !== page && isFetching) {
      prevPageRef.current = page
      setPageChanged(true)
    }
    if (prevFiltersRef.current !== filterValues && isFetching) {
      prevFiltersRef.current = filterValues
      setPageChanged(true)
    } else {
      setPageChanged(false)
    }
  }, [isFetching, page, filterValues])


  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return (
      permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
    )
  }

 

  const businessUnitFilters = [
    <TextInput label={translate('ra.field.id')} source='id' />,
    <TextInput label={translate('ra.field.short_name')} source='short_name__ilike' />,
    <TextInput label={translate('ra.field.long_name')} source='long_name__ilike' />,
    <TextInput label={translate('ra.field.fantasy_name')} source='fantasy_name__ilike' />,
    <TextInput label={translate('ra.field.business_name')} source='fiscal_data__name__ilike' />,
    <TextInput label={translate('ra.field.document_number')} source='fiscal_data__document_number__ilike' />,
    <TextInput label={translate('ra.field.state')} source='state__ilike' />,
    <CountryInput label={translate('ra.field.country')} source='country_id' />,
    <ResponsibleInput
      label={translate('ra.field.manager_responsible')}
      source='user_id'
    />,
    <ResponsibleInput
      label={translate('ra.field.commercial_responsible')}
      source='salesperson_user_id'
    />,
    <BusinessUnitInput label={translate('ra.field.parent_businessunit')} source='parent_id' />,
    <TextInput label={translate('ra.field.tma_code')} source='fiscal_data__tma_code__ilike' />,
    <WorkUnitInput label={translate('ra.field.work_unit')} source='work_unit_id__in' />,
    <BooleanInput label={translate('ra.field.is_active')} source='is_active' />,
    <BooleanInput label={translate('ra.field.is_agency')} source='is_agency' />,
    <BooleanInput label={translate('ra.title.condition')} source='has_condition' />,
    <SelectInput style={{width:'200px'}} choices={CATEGORY_OPTIONS} label={translate('ra.field.category')} source='category__ilike' />,
  ]


  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.business-unit')}>
        <List
          {...props}
          component='div'
          filters={businessUnitFilters}
          actions={
            <ListViewTopToolbar
              hasCreate={permissions?.hasCreate}
              exporterDisable={true}
              CustomExportButton={
                hasPermissionFunction('business-unit', PERMISSION_EXPORT) ? BusinessUnitExportButton : null
              }
            />
          }
          exporter={false}
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={pageChanged}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField
              source='fiscal_data_name'
              label={translate('ra.field.business_name')}
              sortable={false}
            />
            <TextField source='fantasy_name' label={translate('ra.field.fantasy_name')} sortable={false} />
            <TextField
              source='document_number'
              label={translate('ra.field.document_number')}
              sortable={false}
            />
            <TextField source='tma_code' label={translate('ra.field.tma_code')} sortable={false} />
            <TextField
              source='work_unit_short_name'
              label={translate('ra.field.work_unit')}
              sortable={false}
            />
            <TextField
              source='parent_fiscal_data_name'
              label={translate('ra.field.parent_businessunit')}
              sortable={false}
            />
            <BooleanField label={translate('ra.field.is_agency')} source='is_agency' sortable={false} />
            <BooleanField label={translate('ra.field.is_active')} source='is_active' sortable={false} />
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['short_name']}
                DeleteButtonComponent={DeleteButtonWithConfirmation}
                genderElement='femenine'
                disableRevision
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
